import React, { useState } from 'react';
import { Row, Col, Card, Badge, Modal, Button, Table } from 'react-bootstrap';
import * as FaIcons from 'react-icons/fa';

const ResumenFinanciero = ({ resumenDiario, fechaConsulta, formatearMonto, formatearPorcentaje, formatearFechaDisplay }) => {
  const [showModalEmpresas, setShowModalEmpresas] = useState(false);

  // Función para obtener color de empresa
  const obtenerColorEmpresa = (sigla) => {
    const colores = {
      'MER': 'primary',
      'CER': 'success', 
      'SPR': 'warning',
      'LOG': 'info',
      'DIS': 'danger'
    };
    return colores[sigla] || 'dark';
  };

  if (!resumenDiario?.resumen) {
    return (
      <div className="text-center p-5">
        <FaIcons.FaChartBar style={{ fontSize: '3rem', color: '#dee2e6', marginBottom: '16px' }} />
        <h6 style={{ color: '#6c757d' }}>No hay datos disponibles para mostrar</h6>
      </div>
    );
  }

  const { resumen } = resumenDiario;

  return (
    <>
      {/* Header del Resumen */}
      <Row className="mb-4">
        <Col xs={12}>
          <h5 className="mb-3">
            <FaIcons.FaChartBar className="me-2" style={{ color: '#1976d2' }} />
            Resumen Financiero del {formatearFechaDisplay(fechaConsulta)}
          </h5>
        </Col>
      </Row>

      {/* Métricas Principales */}
      <Row className="mb-4">
        <Col xs={12} sm={6} lg={3} className="mb-3">
          <Card className="border-0 bg-info text-white h-100 shadow-sm">
            <Card.Body className="text-center">
              <FaIcons.FaFileAlt style={{ fontSize: '2.5rem', marginBottom: '12px' }} />
              <h3 className="mb-1">{resumen.total_guias?.toLocaleString() || 0}</h3>
              <small className="opacity-75">Guías Totales</small>
            </Card.Body>
          </Card>
        </Col>

        <Col xs={12} sm={6} lg={3} className="mb-3">
          <Card className="border-0 bg-success text-white h-100 shadow-sm">
            <Card.Body className="text-center">
              <FaIcons.FaCheckCircle style={{ fontSize: '2.5rem', marginBottom: '12px' }} />
              <h3 className="mb-1">{resumen.guias_entregadas?.toLocaleString() || 0}</h3>
              <small className="opacity-75">Guías Entregadas</small>
            </Card.Body>
          </Card>
        </Col>

        <Col xs={12} sm={6} lg={3} className="mb-3">
          <Card className="border-0 bg-warning text-white h-100 shadow-sm">
            <Card.Body className="text-center">
              <FaIcons.FaPercentage style={{ fontSize: '2.5rem', marginBottom: '12px' }} />
              <h3 className="mb-1">{formatearPorcentaje(resumen.porcentaje_entrega)}</h3>
              <small className="opacity-75">Nivel de Servicio</small>
            </Card.Body>
          </Card>
        </Col>

        <Col xs={12} sm={6} lg={3} className="mb-3">
          <Card className="border-0 bg-primary text-white h-100 shadow-sm">
            <Card.Body className="text-center">
              <FaIcons.FaRoute style={{ fontSize: '2.5rem', marginBottom: '12px' }} />
              <h3 className="mb-1">{resumen.total_rutas?.toLocaleString() || 0}</h3>
              <small className="opacity-75">Rutas Ejecutadas</small>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      {/* Información Financiera */}
      <Row className="mb-4">
        <Col xs={12}>
          <Card className="shadow-sm border-0">
            <Card.Header className="bg-light border-0">
              <h6 className="mb-0">
                <FaIcons.FaDollarSign className="me-2" style={{ color: '#28a745' }} />
                Resumen Financiero
              </h6>
            </Card.Header>
            <Card.Body>
              <Row>
                <Col xs={12} md={4} className="mb-3">
                  <div className="text-center p-3 bg-light rounded">
                    <FaIcons.FaArrowDown className="text-danger mb-2" style={{ fontSize: '1.5rem' }} />
                    <h4 className="text-danger mb-1">{formatearMonto(resumen.monto_total_ingreso)}</h4>
                    <small className="text-muted">Ingresos Totales</small>
                  </div>
                </Col>
                <Col xs={12} md={4} className="mb-3">
                  <div className="text-center p-3 bg-light rounded">
                    <FaIcons.FaArrowUp className="text-warning mb-2" style={{ fontSize: '1.5rem' }} />
                    <h4 className="text-warning mb-1">{formatearMonto(resumen.monto_total_egreso)}</h4>
                    <small className="text-muted">Egresos Totales</small>
                  </div>
                </Col>
                <Col xs={12} md={4} className="mb-3">
                  <div className="text-center p-3 bg-light rounded">
                    <FaIcons.FaChartLine className="text-success mb-2" style={{ fontSize: '1.5rem' }} />
                    <h4 className="text-success mb-1">{formatearMonto(resumen.margen_absoluto_total)}</h4>
                    <small className="text-muted">Margen Total</small>
                  </div>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      {/* Distribución de Estados */}
      {resumenDiario.distribucion_estados && (
        <Row className="mb-4">
          <Col xs={12}>
            <Card className="shadow-sm border-0">
              <Card.Header className="bg-light border-0">
                <h6 className="mb-0">
                  <FaIcons.FaChartPie className="me-2" style={{ color: '#6f42c1' }} />
                  Distribución de Estados de Entrega
                </h6>
              </Card.Header>
              <Card.Body>
                <Row>
                  {Object.entries(resumenDiario.distribucion_estados)
                    .sort(([,a], [,b]) => b - a)
                    .slice(0, 6)
                    .map(([estado, cantidad], index) => (
                    <Col xs={12} sm={6} md={4} lg={2} key={estado} className="mb-3">
                      <div className="text-center">
                        <Badge 
                          bg={estado === 'Entrega exitosa' ? 'success' : 
                              estado.toLowerCase().includes('rechaza') ? 'danger' :
                              estado.toLowerCase().includes('ruta') ? 'primary' : 'secondary'}
                          className="p-2 w-100"
                        >
                          {cantidad}
                        </Badge>
                        <small className="d-block mt-1 text-muted" style={{ fontSize: '0.75rem' }}>
                          {estado}
                        </small>
                      </div>
                    </Col>
                  ))}
                </Row>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      )}

      {/* Resumen de Empresas */}
      {resumenDiario.detalle_empresas && (
        <Row className="mb-4">
          <Col xs={12}>
            <Card className="shadow-sm border-0">
              <Card.Header className="bg-light border-0">
                <Row className="align-items-center">
                  <Col>
                    <h6 className="mb-0">
                      <FaIcons.FaBuilding className="me-2" style={{ color: '#fd7e14' }} />
                      Resumen por Empresa ({resumenDiario.detalle_empresas.length} empresas)
                    </h6>
                  </Col>
                  {resumenDiario.detalle_empresas.length > 4 && (
                    <Col xs="auto">
                      <Button
                        variant="outline-primary"
                        size="sm"
                        onClick={() => setShowModalEmpresas(true)}
                      >
                        <FaIcons.FaEye className="me-1" />
                        Ver Todas
                      </Button>
                    </Col>
                  )}
                </Row>
              </Card.Header>
              <Card.Body>
                <Row>
                  {resumenDiario.detalle_empresas
                    .sort((a, b) => b.total_guias - a.total_guias)
                    .slice(0, 4)
                    .map((empresa, index) => (
                    <Col xs={12} sm={6} md={3} key={empresa.empresa.id} className="mb-3">
                      <Card className="border h-100">
                        <Card.Body className="text-center">
                          <Badge bg={obtenerColorEmpresa(empresa.empresa.sigla)} className="mb-2 px-3 py-2 fw-bold">
                            {empresa.empresa.sigla}
                          </Badge>
                          <div className="mb-2">
                            <small className="text-muted d-block">Guías</small>
                            <strong>{empresa.total_guias?.toLocaleString()}</strong>
                          </div>
                          <div className="mb-2">
                            <small className="text-muted d-block">Conductores</small>
                            <strong>{empresa.total_conductores}</strong>
                          </div>
                          <div>
                            <small className="text-muted d-block">Margen</small>
                            <strong className="text-success">
                              {formatearMonto(empresa.margen_absoluto_total)}
                            </strong>
                          </div>
                        </Card.Body>
                      </Card>
                    </Col>
                  ))}
                </Row>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      )}

      {/* Modal para ver todas las empresas */}
      <Modal show={showModalEmpresas} onHide={() => setShowModalEmpresas(false)} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>
            <FaIcons.FaBuilding className="me-2" />
            Resumen Completo por Empresa
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Table responsive hover>
            <thead className="table-light">
              <tr>
                <th>Empresa</th>
                <th className="text-center">Guías Totales</th>
                <th className="text-center">Guías Entregadas</th>
                <th className="text-center">Conductores</th>
                <th className="text-center">Rutas</th>
                <th className="text-end">Ingresos</th>
                <th className="text-end">Egresos</th>
                <th className="text-end">Margen</th>
              </tr>
            </thead>
            <tbody>
              {resumenDiario.detalle_empresas
                ?.sort((a, b) => b.total_guias - a.total_guias)
                .map((empresa, index) => (
                <tr key={empresa.empresa.id}>
                  <td>
                    <Badge bg={obtenerColorEmpresa(empresa.empresa.sigla)} className="fw-bold">
                      {empresa.empresa.sigla}
                    </Badge>
                  </td>
                  <td className="text-center">
                    <Badge bg="info">{empresa.total_guias?.toLocaleString()}</Badge>
                  </td>
                  <td className="text-center">
                    <Badge bg="success">{empresa.guias_entregadas?.toLocaleString()}</Badge>
                  </td>
                  <td className="text-center">{empresa.total_conductores}</td>
                  <td className="text-center">{empresa.total_rutas}</td>
                  <td className="text-end text-danger">
                    <strong>{formatearMonto(empresa.monto_total_ingreso)}</strong>
                  </td>
                  <td className="text-end text-warning">
                    <strong>{formatearMonto(empresa.monto_total_egreso)}</strong>
                  </td>
                  <td className="text-end text-success">
                    <strong>{formatearMonto(empresa.margen_absoluto_total)}</strong>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModalEmpresas(false)}>
            Cerrar
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ResumenFinanciero;
